import { render, staticRenderFns } from "./editUniRequestForm.vue?vue&type=template&id=21f6d0c0&scoped=true&"
import script from "./editUniRequestForm.vue?vue&type=script&lang=js&"
export * from "./editUniRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./editUniRequestForm.vue?vue&type=style&index=0&id=21f6d0c0&prod&lang=css&"
import style1 from "./editUniRequestForm.vue?vue&type=style&index=1&id=21f6d0c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6d0c0",
  null
  
)

export default component.exports